<!--免疫球蛋白[IgG,IgA,IgM,IgE,IgG4(可选)]-->
<script setup>
import { computed, reactive,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import check from "./check.vue";
import upload from "@/components/upload1.vue"
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});


// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
}

// console.log(props.type)
// &&  != '筛选期（肝穿前96周内资料完整点）±2周'


;
</script>
<template>
  <template v-if="crfFields ">
     <div style="display: flex;">

      <h2>免疫球蛋白[IgG,IgA,IgM,IgE,IgG4(可选)]</h2>
      <upload :type="props.type" :data="model" name="myqdb"></upload>
      <check :period="props.type" text="免疫球蛋白[IgG,IgA,IgM,IgE,IgG4(可选)]" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="免疫球蛋白是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['免疫球蛋白是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['免疫球蛋白是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增免疫球蛋白已测':'免疫球蛋白是否已测'" class="redStar">
            <el-radio-group v-model="crfFields['免疫球蛋白是否已测']">
              <el-radio label="是" prop="是"></el-radio>
              <el-radio label="无" prop="无"></el-radio>
              <!-- <el-radio label="未测" prop="未测"></el-radio> -->
            </el-radio-group>
        </el-form-item>

        <template v-if="crfFields['免疫球蛋白是否已测'] == '是'">
          
            <el-form-item label="免疫球蛋白G（g/L）" class="not_redStar" :prop="itemProp(`免疫球蛋白G`)" :rules="crfStore.textRules(`免疫球蛋白G`,true)">
              <el-input v-model="crfFields['免疫球蛋白G']" autocomplete="off">
                <template #append>g/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="免疫球蛋白M（g/L）" class="not_redStar" :prop="itemProp(`免疫球蛋白M`)" :rules="crfStore.textRules(`免疫球蛋白M`,true)">
              <el-input v-model="crfFields['免疫球蛋白M']" autocomplete="off">
                <template #append>g/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="补体C3（g/L）" class="not_redStar" :prop="itemProp(`补体C3`)" :rules="crfStore.textRules(`补体C3`,true)">
              <el-input v-model="crfFields['补体C3']" autocomplete="off">
                <template #append>g/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="补体C4（g/L）" class="not_redStar" :prop="itemProp(`补体C4`)" :rules="crfStore.textRules(`补体C4`,true)">
              <el-input v-model="crfFields['补体C4']" autocomplete="off">
                <template #append>g/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="IgG4（g/L）" class="not_redStar" :prop="itemProp(`IgG4`)" :rules="crfStore.textRules(`IgG4`,true)">
              <el-input v-model="crfFields['IgG4']" autocomplete="off">
                <template #append>g/L</template></el-input>
            </el-form-item>
            <el-form-item label="CRP（mg/L）" class="not_redStar" :prop="itemProp(`CRP`)" :rules="crfStore.textRules(`CRP`,true)">
              <el-input v-model="crfFields['CRP']" autocomplete="off">
                <template #append>mg/L</template>
              </el-input>
            </el-form-item>
        </template>
      </template>

  </template>
</template>

<style scoped>
</style>